import PrintReport from "../";

const routes = [
    { name: "PrintReportList", path: "/printreport", component: PrintReport.PrintReportList, meta: { title: "PrintReport" } },
    { name: "PrintReportView", path: "/printreport/view/:id", component: PrintReport.PrintReportView, meta: { title: "PrintReport" } },
    { name: "PrintReportEdit", path: "/printreport/edit/:id", component: PrintReport.PrintReportEdit, meta: { title: "PrintReport" } },
];

export default routes;
